module.exports = __webpack_public_path__ + "img/1_02.7935c9bb.jpg";